import {format} from "isoformat";

export default function formatDate(date) {
  return format(date, "Invalid Date");
}
